import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataService } from "../../data.service";
import { GtagService } from "../../gtag/gtag.service";
import { CargoFeaturesModel } from "../../model";
import { AuthService } from "../auth.service";

@Component({
    selector: 'app-mobile-login',
    templateUrl: './mobile-app-login.component.html',
    styleUrls: ['./mobile-app-login.component.css'],
    standalone: false
})
export class MobileAppLoginComponent implements OnInit {
    cargoFeatures?: CargoFeaturesModel;
    otpCode: String ="";

    constructor(private authService: AuthService, private dataService: DataService, private router: Router, private gt: GtagService) {
        this.gt.pageview2('MobileAppLogin');

        this.authService.cargoFeatures().then((cargoFeatures: CargoFeaturesModel) => {
            this.cargoFeatures = cargoFeatures;
        });

        this.createOTPCode();
    }

    createOTPCode() {
        this.authService.getOTPCode().subscribe((code: String) => {
            this.otpCode = code;
        });
    }
        
       
    ngOnInit() {
    }
}